import { render, staticRenderFns } from "./IconSettings.vue?vue&type=template&id=92985c2e&"
import script from "./IconSettings.vue?vue&type=script&lang=js&"
export * from "./IconSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92985c2e')) {
      api.createRecord('92985c2e', component.options)
    } else {
      api.reload('92985c2e', component.options)
    }
    module.hot.accept("./IconSettings.vue?vue&type=template&id=92985c2e&", function () {
      api.rerender('92985c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSettings.vue"
export default component.exports